import React, { useEffect } from 'react';

const EmailNotifications = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: EmailNotifications is not implemented yet.');
  }, []);
  return (
    <>
  { /*EmailNotifications */} 
 </>
  );
};

export default EmailNotifications;
